import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "./services/api";
import authReducer from "./features/authSlice";
import dashboardReducer from "./features/dashboardSlice";
import currencyConverterReducer from "./features/currencyConverterSlice";
import adsReducer from "./features/adsSlice";
import requestReducer from "./features/requestSlice";
import miscReducer from "./features/miscSlice";

// Import API services to inject their endpoints
import "./services/authApi";
import "./services/dashboardApi";
import "./services/currencyApi";
import "./services/adsApi";
import "./services/requestApi";
import "./services/miscApi";
import "./services/walletApi";
import "./services/adminApi";
import "./services/disputeApi";
import "./services/userApi";
import "./services/bookingApi";
import "./services/artisanApi";

export const store = configureStore({
	reducer: {
		auth: authReducer,
		dashboard: dashboardReducer,
		currencyConverter: currencyConverterReducer,
		ads: adsReducer,
		request: requestReducer,
		misc: miscReducer,
		[api.reducerPath]: api.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(api.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
